import HttpClient from "../httpClient";
import { Parameter, ParameterFilter, CreateParameter, UpdateParameter } from "../../models/types/parameter";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";
import { getQuery } from "../../utils/helper";

class ParameterService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<ParameterFilter>): Promise<DefaultResponseContent<Parameter[]>> {
        const response = await this.service.get<DefaultResponseContent<Parameter[]>>("/admin/Parameter/GetAll", requestData);
        return response;
    }

    async getLookup(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Parameter/GetLookup");
        return response;
    }

    async getLookupByStation(stationIds: number[]): Promise<DefaultResponse<any[]>> {
        const queryString = getQuery({ stationIds });
        const response = await this.service.get<DefaultResponse<any[]>>(`/admin/Parameter/GetLookUpByStationId${queryString}`);
        return response;
    }

    async getParameterById(id: string): Promise<DefaultResponse<Parameter>> {
        const response = await this.service.get<DefaultResponse<Parameter>>(`/admin/Parameter/GetDetail/${id}`);
        return response;
    }

    async createParameter(requestData: CreateParameter): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Parameter/Create`, requestData);
        return response;
    }

    async updateParameter(requestData: UpdateParameter): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Parameter/Update`, requestData);
        return response;
    }

    async deleteParameter(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/Parameter/Delete/${id}`);
        return response;
    }

}

const parameterSvc = new ParameterService();
export default parameterSvc;
